export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/check-9a9130d651766fcac939146b9b681762.svg";